export default __webpack_public_path__ + "4aeaee560b2277564d9e19e8082813e8.png";